export default "__VITE_ASSET__B2oQD$r5__"